import * as React from 'react'

const Polygon = (props: any) => (
  <svg {...props} viewBox='0 0 8 5' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M3.93939 0L7.35101 4.5H0.527779L3.93939 0Z' transform='rotate(-180 3.94 2.5)' />
  </svg>
)

export default Polygon



// WEBPACK FOOTER //
// ./src/components/icons/ui/Polygon.tsx